import createHashHistory from 'history/lib/createHashHistory';
import createRouterHistory from './createRouterHistory';
export default createRouterHistory(createHashHistory);


//////////////////
// WEBPACK FOOTER
// ../~/_react-router@3.2.4@react-router/es/hashHistory.js
// module id = 1562
// module chunks = 1